<template>
	<div v-if="menu.length" class="footer-class-nav container-fluid">
		<!-- home previous item -->
		<template v-if="isClassItemPage">
			<a @click.prevent="goToHome()" href="#" v-if="+currentSection === 0" class="class-nav-prev">
				<i class="fas fa-chevron-left fa-2x" aria-hidden="true"></i>
				<page-icon v-bind="homeIconProps"></page-icon>
				<span class="hidden-sm hidden-xs name">{{ $t( 'MAIN_CONTENT.classPage.ClassNav.classPage_classHome' ) }}</span>
			</a>
			<a @click.prevent="goToSection(menu[ currentIndex ].FOLDER_ID)"
				 href="#"
				 v-else-if="currentSection > 0"
				 class="class-nav-prev">
				<i class="fas fa-chevron-left" aria-hidden="true"></i>
				<page-icon 
					:text="menu[ currentSection ].FOLDER_NAME.toString().charAt(0)" 
					:color="getColor( currentSection - 1 )"
					:image="menu[ currentSection ].PAGE_ICON_URL ? `url(${menu[ currentSection ].PAGE_ICON_URL })` : ''"
				></page-icon>
				<span class="hidden-sm hidden-xs name">
					{{ menu[ currentSection ].FOLDER_NAME }}
				</span>
			</a>
		</template>
		<template v-else>
			<a @click.prevent="goToHome()" href="#" v-if="currentIndex === 0" class="class-nav-prev">
				<i class="fas fa-chevron-left fa-2x" aria-hidden="true"></i>
				<page-icon v-bind="homeIconProps"></page-icon>
				<span class="hidden-sm hidden-xs name">{{ $t( 'MAIN_CONTENT.classPage.ClassNav.classPage_classHome' ) }}</span>
			</a>
			<!-- menu previus item -->
			<a @click.prevent="goToSection(menu[ prevIndex ].FOLDER_ID)"
				 href="#"
				 v-else-if="currentIndex > 0"
				 class="class-nav-prev">
				<i class="fas fa-chevron-left" aria-hidden="true"></i>
				<page-icon 
					:text="menu[ prevIndex ].FOLDER_NAME.toString().charAt(0)" 
					:color="getColor( prevIndex )"
					:image="menu[ prevIndex ].PAGE_ICON_URL ? `url(${menu[ prevIndex ].PAGE_ICON_URL })` : ''"
				></page-icon>
				<span class="hidden-sm hidden-xs name">
					 {{ menu[ prevIndex ].FOLDER_NAME }}
				</span>
			</a>

			<!-- menu next item -->
			<a @click.prevent="goToSection(nextMenuItem.FOLDER_ID)"
				 href="#"
				 v-if="+currentIndex + 1 < menu.length"
				 class="class-nav-next">
				<span class="hidden-sm hidden-xs name">
					{{ nextMenuItem.FOLDER_NAME }}
				</span>
				<page-icon 
					:text="menu[ nextIndex ].FOLDER_NAME.toString().charAt(0)" 
					:color="getColor( nextIndex )"
					:image="menu[ nextIndex ].PAGE_ICON_URL ? `url(${menu[ nextIndex ].PAGE_ICON_URL })` : ''"
				></page-icon>
				<i class="fas fa-chevron-right fa-2x" aria-hidden="true"></i>
			</a>
		</template>
	</div>
</template>

<script>
	import PageIcon from "./PageIcon.vue";

	import { mapState } from "vuex";

	export default {
		props: {
			currentSection : { // muenu order number
				type: Number,
				default: 0
			},
			course: {
				type: Object,
				default: () => {},
			},
			menu: {
				type: Array,
				default: () => [],
			},
			courseContent: {
				type: Object,
				default: () => {},
			},
			isClassItemPage: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				mediaPath : '/CommunityWebPortal/_app/includes/static/images/profiles/',
				classPagePath : '/cwp/studentClassPage'
			};
		},
		computed: {
			isClassHome() {
				return this.currentSection === 0;
			},
			isClassHomeAndNotItemPage() {
				return this.currentSection === 0 && !this.isClassItemPage;
			},
			currentIndex() {
				if ( +this.currentSection === 0 ) {
					return -1;
				} else {
					return  this.menu.findIndex( item => item.FOLDER_ID === this.currentSection );
				}
			},
			nextIndex() {
				return this.currentIndex + 1;
			},
			prevIndex() {
				return this.currentIndex - 1;
			},
			nextMenuItem() {
				return  this.menu[ this.nextIndex ];
			},
			homeIconProps() {
				let current = {};
				 if( !!this.courseContent && this.courseContent.hasOwnProperty("PAGE_ICON_URL") ){
					current.image = 'url(' + this.courseContent.PAGE_ICON_URL + ')';
					current.text = '';
				}
				else if( this.course.TEACHER_IMAGE ) {
					current.image = 'url(' + this.mediaPath + this.course.TEACHER_IMAGE + ')';
				} else {
					current.image = 'url(' + this.mediaPath + 'no-staff-image.png )';
				}

				return current;
			}
		},
		components: {
			PageIcon
		},
		methods : {
			getColor( index ) {
				return this.menu[index].PAGE_ICON_COLOR;
			},
			goToSection(folderId) {
				this.$router.push({
					name: 'ClassPageSection',
					params: {
						courseSectionGUID: this.$route.params.courseSectionGUID,
						folderId: folderId
					}
				});
			},
			goToHome(){
				this.$router.push({
					name: 'ClassPageHome',
					params: {
						courseSectionGUID: this.$route.params.courseSectionGUID
					}
				});
			}
		}
	}
</script>
